import React from "react";
import { Segment, Dropdown, Button, Icon } from "semantic-ui-react";
import "./DashboardHeader.scss";

export function DashboardHeader(props) {
  const { cycleOptions, selectedCycle, onCycleChange, onRefresh, refreshing } =
    props;

  return (
    <Segment className="dashboard-header">
      <div className="dashboard-title">
        <h1>Dashboard Administrativo</h1>
        <p>Resumen general de la institución</p>
      </div>
      <div className="dashboard-actions">
        {cycleOptions.length > 0 && (
          <Dropdown
            selection
            options={cycleOptions}
            value={selectedCycle}
            onChange={(e, { value }) => onCycleChange(value)}
            placeholder="Seleccionar ciclo académico"
            className="cycle-selector edunova-select"
          />
        )}
        <Button
          icon
          onClick={onRefresh}
          loading={refreshing}
          disabled={refreshing}
        >
          <Icon name="refresh" />
          Actualizar
        </Button>
      </div>
    </Segment>
  );
}
